import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React, {ReactElement, useState} from 'react';

type Props<T> = {
    label : string;
    value : T;
    options : Array<{
        value : T;
        label : string;
    }>;
    onChange : (value : T) => void;
};

const ListSelectItem = <T extends unknown>({label, value, options, onChange} : Props<T>) : ReactElement => {
    const [selectOpen, setSelectOpen] = useState(false);
    const currentOption = options.find(option => option.value === value);

    return (
        <React.Fragment>
            <ListItem disableGutters button onClick={() => setSelectOpen(true)}>
                <ListItemText secondary={currentOption && currentOption.label}>{label}</ListItemText>
            </ListItem>

            <Dialog
                open={selectOpen}
                onClose={() => setSelectOpen(false)}
                fullWidth
                maxWidth="xs"
            >
                <DialogContent>
                    <List>
                        {options.map((option, index) => (
                            <ListItem key={index} disableGutters button onClick={() => {
                                onChange(option.value);
                                setSelectOpen(false)
                            }}>
                                <ListItemText>{option.label}</ListItemText>
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default ListSelectItem;
